// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pen-mark"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 6.5L17.5 2L5 14.5L4.49902 16.4993L7.5 19.5L9.5 19L22 6.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 6.5L17.5 2L5 14.5L4.49902 16.4993L7.5 19.5L9.5 19L22 6.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4.5 21.5L2.5 19.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PenMarkIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-mark',
    ref,
    icon: element,
  },
));

PenMarkIcon.displayName = 'PenMarkIcon';

export default PenMarkIcon;
